import { StyleSheet } from 'aphrodite';
import { grayIconFill } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: `flex`,
		flexDirection: `column`,
		overflow: `hidden`,
	},
	rows: {
		display: `flex`,
		flexDirection: `column`,
		overflow: `auto`,
	},
	deletedAccounts: {
		color: grayIconFill,
		letterSpacing: '1.1px',
		margin: '20px 0 30px',
		textAlign: 'center',
		textTransform: 'uppercase',
	},
	noneFound: {
		color: '#4a4a4a',
		fontSize: 14,
		marginTop: 30,
		textAlign: 'center',
		width: '100%',
	},
	spinnerContainer: {
		display: 'flex',
		justifyContent: 'center',
		margin: 30,
	},
});
